import React, { Component } from 'react';
import { ArrowLeft, Phone, MessageSquare, Calendar, Package, User, Building2, Clock, Search, FileText, Loader, ChevronLeft, ChevronRight } from 'lucide-react';
import axios from 'axios';
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
import host from "./host";

const cookies = new Cookies();

class OrderDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            orders: [],
            filteredOrders: [],
            loading: true,
            error: null,
            currentStatus: 'كاذب',
            selectedOrderId: null,
            // Pagination state
            currentPage: 1,
            itemsPerPage: 10,
            totalOrders: 0,
            totalPages: 0
        };
    }

    componentDidMount() {
        this.fetchOrders();
    }

    // جلب الطلبات من API مع pagination
    fetchOrders = async (status = 'شركة التوصيل', page = 1, searchTerm = '') => {
        try {
            this.setState({ loading: true, error: null });

            const encodedStatus = encodeURIComponent(status);
            let url = `${host}users/shppingmtab3a-orders?status=${encodedStatus}&page=${page}&limit=${this.state.itemsPerPage}`;
            
            // إضافة معامل البحث إذا كان موجود
            if (searchTerm && searchTerm.trim() !== '') {
                url += `&search=${encodeURIComponent(searchTerm)}`;
            }

            const response = await axios.get(url);

            this.setState({
                orders: response.data.orders || [],
                filteredOrders: response.data.orders || [],
                totalOrders: response.data.totalOrders || 0,
                totalPages: response.data.totalPages || 0,
                currentPage: page,
                loading: false,
                currentStatus: status
            });
        } catch (error) {
            console.error('Error fetching orders:', error);
            this.setState({
                error: 'حدث خطأ في جلب البيانات',
                loading: false
            });
        }
    };

    // تغيير الصفحة
    handlePageChange = (page) => {
        if (page >= 1 && page <= this.state.totalPages) {
            this.fetchOrders(this.state.currentStatus, page, this.state.searchTerm);
        }
    };

    // البحث في الطلبات
    handleSearch = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm });

        // إعادة تعيين الصفحة للأولى عند البحث
        this.fetchOrders(this.state.currentStatus, 1, searchTerm);
    };

    // إجراء مكالمة
    handleCall = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };

    // تحويل للواتساب
    handleWhatsApp = (phoneNumber) => {
        let formattedPhone = phoneNumber;
        if (phoneNumber.startsWith('07')) {
            formattedPhone = '964' + phoneNumber.substring(1);
        }
        window.open(`https://wa.me/${formattedPhone}`);
    };

    // فتح مودل المعالجة
    openModal = (orderId) => {
        this.setState({ showModal: true, selectedOrderId: orderId });
    };

    // إغلاق المودل
    closeModal = () => {
        this.setState({
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            selectedOrderId: null
        });
    };

    // تغيير الحالة المختارة
    handleStatusChange = (status) => {
        this.setState({ selectedStatus: status });
    };

    // تغيير التاريخ
    handleDateChange = (e) => {
        this.setState({ postponeDate: e.target.value });
    };

    // تحويل التاريخ من YYYY-MM-DD إلى DD/MM/YYYY
    formatDateForAPI = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch {
            return dateString;
        }
    };

    // إرسال التحديث
    handleSubmit = async () => {
        try {
            this.setState({ loading: true });

            const requestData = {
                id: this.state.selectedOrderId,
                status: this.state.selectedStatus
            };

            if (this.state.selectedStatus === 'مؤجل' && this.state.postponeDate) {
                requestData.Delayed = this.formatDateForAPI(this.state.postponeDate);
            }

            console.log('البيانات المرسلة:', requestData);

            const response = await axios.post(`${host}users/mtab3a-orders/update/`, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': cookies.get("token")
                }
            });

            console.log('تم تحديث الحالة بنجاح:', response.data);
            alert('تم تحديث الحالة بنجاح');

            this.closeModal();
            await this.fetchOrders(this.state.currentStatus, this.state.currentPage, this.state.searchTerm);

        } catch (error) {
            console.error('تفاصيل الخطأ:', error);

            let errorMessage = 'حدث خطأ في تحديث الحالة';

            if (error.response) {
                console.log('Response data:', error.response.data);
                console.log('Response status:', error.response.status);
                console.log('Response headers:', error.response.headers);
                errorMessage = `خطأ من الخادم: ${error.response.status} - ${error.response.data.message || error.response.data}`;
            } else if (error.request) {
                console.log('Request data:', error.request);
                errorMessage = 'لم يتم الحصول على رد من الخادم. تحقق من الاتصال.';
            } else {
                console.log('Error message:', error.message);
                errorMessage = `خطأ في الطلب: ${error.message}`;
            }

            alert(errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    // العودة للصفحة السابقة
    goBack = () => {
        window.history.back();
    };

    // فك ترميز النص العربي
    decodeArabicText = (text) => {
        try {
            return decodeURIComponent(text.replace(/\+/g, ' '));
        } catch {
            return text;
        }
    };

    // تنسيق التاريخ بتوقيت بغداد بدون ثواني
    formatDate = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY HH:mm');
        } catch {
            return dateString;
        }
    };

    // تنسيق التاريخ فقط بدون وقت
    formatDateOnly = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY');
        } catch {
            return dateString;
        }
    };

    // تنسيق الوقت النسبي (منذ كم دقيقة/ساعة/يوم)
    formatRelativeTime = (dateString) => {
        try {
            const now = moment().tz('Asia/Baghdad');
            const date = moment(dateString).tz('Asia/Baghdad');
            const diffMinutes = now.diff(date, 'minutes');
            const diffHours = now.diff(date, 'hours');
            const diffDays = now.diff(date, 'days');

            if (diffMinutes < 60) {
                return `منذ ${diffMinutes} دقيقة`;
            } else if (diffHours < 24) {
                return `منذ ${diffHours} ساعة`;
            } else if (diffDays < 7) {
                return `منذ ${diffDays} يوم`;
            } else {
                return this.formatDate(dateString);
            }
        } catch {
            return dateString;
        }
    };

    render() {
        const {
            searchTerm,
            filteredOrders,
            showModal,
            selectedStatus,
            postponeDate,
            loading,
            error,
            currentPage,
            totalPages,
            totalOrders
        } = this.state;

        const statusOptions = ['لايرد', 'كاذب', 'شركة التوصيل', 'خطأ بالتجهيز', 'مؤجل', 'تم المعالجة'];

        const styles = {
            container: {
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                direction: 'rtl'
            },
            header: {
                backgroundColor: '#ffffff',
                padding: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'sticky',
                top: 0,
                zIndex: 10
            },
            headerContent: {
                maxWidth: '768px',
                margin: '0 auto'
            },
            topRow: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
            },
            pageTitle: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#1f2937',
                textAlign: 'center',
                flex: 1,
                marginRight: '1rem'
            },
            searchRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
            },
            searchLabel: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                whiteSpace: 'nowrap'
            },
            backButton: {
                padding: '0.75rem',
                backgroundColor: '#e2e8f0',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s',
                minWidth: '48px',
                height: '48px'
            },
            searchInput: {
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'right'
            },
            content: {
                maxWidth: '768px',
                margin: '0 auto',
                padding: '1rem'
            },
            // إضافة إحصائيات
            statsContainer: {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb',
                textAlign: 'center'
            },
            statsTitle: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '0.5rem'
            },
            statsNumber: {
                fontSize: '2rem',
                fontWeight: 'bold',
                color: '#3b82f6'
            },
            loading: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                flexDirection: 'column',
                gap: '1rem'
            },
            error: {
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '1rem',
                borderRadius: '0.5rem',
                textAlign: 'center'
            },
            orderCard: {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb'
            },
            orderHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #e5e7eb'
            },
            orderNumber: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937'
            },
            price: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#059669'
            },
            section: {
                marginBottom: '1.5rem'
            },
            sectionTitle: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            customerInfo: {
                backgroundColor: '#f9fafb',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginBottom: '1rem'
            },
            phoneButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '0.5rem'
            },
            phoneButton: {
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.875rem',
                fontWeight: '500'
            },
            callButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            whatsappButton: {
                backgroundColor: '#25d366',
                color: 'white'
            },
            itemsList: {
                backgroundColor: '#f0f9ff',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '2px solid #0ea5e9',
                boxShadow: '0 2px 8px rgba(14, 165, 233, 0.1)'
            },
            item: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                marginBottom: '0.5rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                borderRight: '4px solid #0ea5e9',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                fontSize: '1rem',
                fontWeight: '500'
            },
            historyItem: {
                backgroundColor: '#f3f4f6',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                marginBottom: '0.5rem',
                borderRight: '4px solid #3b82f6'
            },
            relativeTime: {
                backgroundColor: '#dbeafe',
                color: '#1e40af',
                padding: '0.25rem 0.5rem',
                borderRadius: '0.25rem',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                display: 'inline-block',
                border: '1px solid #3b82f6'
            },
            // تحسين عرض اسم شركة التوصيل
            shippingCompany: {
                backgroundColor: '#fef3c7',
                padding: '1rem',
                borderRadius: '0.75rem',
                border: '2px solid #f59e0b',
                marginBottom: '1rem',
                textAlign: 'center'
            },
            shippingCompanyName: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#92400e',
                marginBottom: '0.5rem'
            },
            shippingDate: {
                fontSize: '0.875rem',
                color: '#78716c',
                fontWeight: '500'
            },
            processButton: {
                width: '100%',
                padding: '1rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                marginTop: '1rem'
            },
            // Pagination styles
            paginationContainer: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                marginTop: '2rem',
                padding: '1rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            },
            paginationButton: {
                padding: '0.5rem 1rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                backgroundColor: '#ffffff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            paginationButtonDisabled: {
                opacity: 0.5,
                cursor: 'not-allowed'
            },
            paginationInfo: {
                fontSize: '0.875rem',
                color: '#6b7280'
            },
            modal: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                padding: '1rem'
            },
            modalContent: {
                backgroundColor: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                maxWidth: '400px',
                width: '100%',
                maxHeight: '80vh',
                overflowY: 'auto'
            },
            modalTitle: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                textAlign: 'center'
            },
            statusOption: {
                padding: '0.75rem',
                margin: '0.25rem 0',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.2s'
            },
            statusOptionSelected: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6'
            },
            dateInput: {
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                marginTop: '1rem'
            },
            modalButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '1.5rem'
            },
            modalButton: {
                flex: 1,
                padding: '0.75rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontWeight: '600'
            },
            submitButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            cancelButton: {
                backgroundColor: '#6b7280',
                color: 'white'
            },
            noData: {
                textAlign: 'center',
                padding: '2rem',
                color: '#6b7280'
            }
        };

        if (loading) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.loading}>
                            <Loader className="animate-spin" size={40} />
                            <p>جاري تحميل الطلبات...</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.error}>
                            {error}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.headerContent}>
                        <div style={styles.topRow}>
                            <button style={styles.backButton} onClick={this.goBack}>
                                <ArrowLeft size={24} />
                            </button>
                            <div style={styles.pageTitle}>الطلبات شركة التوصيل</div>
                        </div>
                        <div style={styles.searchRow}>
                            <div style={styles.searchLabel}>البحث عن طلب:</div>
                            <input
                                type="text"
                                placeholder="ابحث برقم الطلب أو رقم الهاتف..."
                                value={searchTerm}
                                onChange={this.handleSearch}
                                style={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div style={styles.content}>
                    {/* إحصائيات */}
                    <div style={styles.statsContainer}>
                        <div style={styles.statsTitle}>العدد الكلي للطلبات</div>
                        <div style={styles.statsNumber}>{totalOrders.toLocaleString()}</div>
                    </div>

                    {filteredOrders.length === 0 ? (
                        <div style={styles.noData}>
                            لا توجد طلبات متطابقة مع البحث
                        </div>
                    ) : (
                        <>
                            {filteredOrders.map(order => (
                                <div key={order.id} style={styles.orderCard}>
                                    {/* Order Header */}
                                    <div style={styles.orderHeader}>
                                        <div style={styles.orderNumber}>طلب رقم: {order.id}</div>
                                        <div style={styles.price}>{order.price.toLocaleString()} د.ع</div>
                                    </div>

                                    {/* شركة التوصيل المحسنة */}
                                    {order.printerOrders && order.printerOrders.length > 0 && (
                                        <div style={styles.shippingCompany}>
                                            <div style={styles.shippingCompanyName}>
                                                📦 {this.decodeArabicText(order.printerOrders[0].prints.name)}
                                            </div>
                                            <div style={styles.shippingDate}>
                                                تاريخ الترحيل: {this.formatDateOnly(order.printerOrders[0].prints.createdAt)}
                                            </div>
                                        </div>
                                    )}

                                    {/* Customer Info */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <User size={20} />
                                            معلومات الزبون
                                        </div>
                                        <div style={styles.customerInfo}>
                                            <div><strong>الاسم:</strong> {this.decodeArabicText(order.name) || 'غير محدد'}</div>
                                            <div><strong>الهاتف:</strong> {order.phone}</div>
                                            <div style={styles.phoneButtons}>
                                                <button
                                                    style={{ ...styles.phoneButton, ...styles.callButton }}
                                                    onClick={() => this.handleCall(order.phone)}
                                                >
                                                    <Phone size={16} />
                                                    اتصال
                                                </button>
                                                <button
                                                    style={{ ...styles.phoneButton, ...styles.whatsappButton }}
                                                    onClick={() => this.handleWhatsApp(order.phone)}
                                                >
                                                    <MessageSquare size={16} />
                                                    واتساب
                                                </button>
                                            </div>
                                            <div style={{ marginTop: '0.5rem' }}>
                                                <strong>العنوان:</strong> {this.decodeArabicText(order.government)} - {this.decodeArabicText(order.city)}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Package size={20} />
                                            مواد الطلب
                                        </div>
                                        <div style={styles.itemsList}>
                                            {order.ordersFormItems && order.ordersFormItems.map((item, index) => (
                                                <div key={index} style={styles.item}>
                                                    <span>{this.decodeArabicText(item.components.name)}</span>
                                                    <span><strong>العدد: {item.count}</strong></span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Notes */}
                                    {order.notes && (
                                        <div style={styles.section}>
                                            <div style={styles.sectionTitle}>
                                                <FileText size={20} />
                                                ملاحظات
                                            </div>
                                            <div style={{ backgroundColor: '#fef3c7', padding: '0.75rem', borderRadius: '0.5rem' }}>
                                                {this.decodeArabicText(order.notes)}
                                            </div>
                                        </div>
                                    )}

                                    {/* History */}
                                    {order.matab3alogs && order.matab3alogs.length > 0 && (
                                        <div style={styles.section}>
                                            <div style={styles.sectionTitle}>
                                                <Clock size={20} />
                                                سجل المتابعة
                                            </div>
                                            {order.matab3alogs.map((log, index) => (
                                                <div key={index} style={styles.historyItem}>
                                                    <div><strong>{this.decodeArabicText(log.user.name)}</strong> - {this.decodeArabicText(log.status)}</div>
                                                    <div style={{ marginTop: '0.5rem' }}>
                                                        <span style={styles.relativeTime}>
                                                            {this.formatRelativeTime(log.updatedAt)}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Order Info */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Building2 size={20} />
                                            معلومات إضافية
                                        </div>
                                        <div style={styles.customerInfo}>
                                            <div><strong>مثبت الطلب:</strong> {this.decodeArabicText(order.user.name)}</div>
                                            <div><strong>الحالة الحالية:</strong> {this.decodeArabicText(order.calls)}</div>
                                            <div style={{ marginTop: '0.5rem' }}>
                                                <strong>تم الإنشاء:</strong> 
                                                <span style={styles.relativeTime}>
                                                    {this.formatRelativeTime(order.createdAt)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Process Button */}
                                    <button style={styles.processButton} onClick={() => this.openModal(order.id)}>
                                        معالجة
                                    </button>
                                </div>
                            ))}

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div style={styles.paginationContainer}>
                                    <button 
                                        style={{
                                            ...styles.paginationButton,
                                            ...(currentPage === 1 ? styles.paginationButtonDisabled : {})
                                        }}
                                        onClick={() => this.handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <ChevronRight size={16} />
                                        السابق
                                    </button>
                                    
                                    <div style={styles.paginationInfo}>
                                        صفحة {currentPage} من {totalPages}
                                    </div>
                                    
                                    <button 
                                        style={{
                                            ...styles.paginationButton,
                                            ...(currentPage === totalPages ? styles.paginationButtonDisabled : {})
                                        }}
                                        onClick={() => this.handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        التالي
                                        <ChevronLeft size={16} />
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Modal */}
                {showModal && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <div style={styles.modalTitle}>تحديث حالة الطلب</div>

                            {statusOptions.map(status => (
                                <div
                                    key={status}
                                    style={{
                                        ...styles.statusOption,
                                        ...(selectedStatus === status ? styles.statusOptionSelected : {})
                                    }}
                                    onClick={() => this.handleStatusChange(status)}
                                >
                                    {status}
                                </div>
                            ))}

                            {selectedStatus === 'مؤجل' && (
                                <input
                                    type="date"
                                    value={postponeDate}
                                    onChange={this.handleDateChange}
                                    style={styles.dateInput}
                                    placeholder="تاريخ التأجيل"
                                />
                            )}

                            <div style={styles.modalButtons}>
                                <button
                                    style={{ ...styles.modalButton, ...styles.submitButton }}
                                    onClick={this.handleSubmit}
                                    disabled={!selectedStatus || (selectedStatus === 'مؤجل' && !postponeDate)}
                                >
                                    تأكيد
                                </button>
                                <button
                                    style={{ ...styles.modalButton, ...styles.cancelButton }}
                                    onClick={this.closeModal}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default OrderDetailsPage;